const BRIDGE_SITE_LIST: Site[] = ["sportsbet"];

const isBridgeSite = (site: Site) => BRIDGE_SITE_LIST.includes(site);

export default isBridgeSite;
